import * as React from 'react';

import { Input as InputPrimitive } from '@base-ui/react/input';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { cn } from '@/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  function Input({ className, type, autoComplete, ...props }, ref) {
    const disableAutocomplete = useFeatureFlag('Remove_Html_Autocomplete');
    const resolvedAutoComplete =
      autoComplete ?? (disableAutocomplete ? 'off' : undefined);

    return (
      <InputPrimitive
        type={type}
        autoComplete={resolvedAutoComplete}
        data-slot="input"
        className={cn(
          'text-foreground dark:bg-input/30 border-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 disabled:bg-input/50 dark:disabled:bg-input/80 file:text-foreground placeholder:text-muted-foreground h-8 w-full min-w-0 rounded-lg border bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-3 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-90 aria-invalid:ring-3 md:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

export { Input };
